
import React from "react";
import { Button } from "@/components/ui/button";
import { ArrowRight, ArrowLeft } from "lucide-react";

interface NavigationButtonsProps {
  currentStage: number;
  totalStages: number;
  selectedCandidate: number | null;
  onPrevious: () => void;
  onNext: () => void;
}

const NavigationButtons: React.FC<NavigationButtonsProps> = ({
  currentStage,
  totalStages,
  selectedCandidate,
  onPrevious,
  onNext,
}) => {
  // Determine if the current stage is the last one
  const isLastStage = currentStage === totalStages - 1;
  
  // Disable next button on the first stage if no candidate is selected
  const isNextDisabled = currentStage === 0 && !selectedCandidate;
  
  // Buttons text based on stage
  const prevButtonText = currentStage === 0 ? "Cancel" : "Previous";
  const nextButtonText = isLastStage ? "Complete" : "Next";
  
  return (
    <div className="flex justify-between mt-8 pt-4 border-t">
      <Button
        variant="outline"
        onClick={onPrevious}
        className="gap-2"
      >
        <ArrowLeft className="h-4 w-4" />
        {prevButtonText}
      </Button>
      
      <Button
        onClick={onNext}
        disabled={isNextDisabled}
        className="gap-2"
      >
        {nextButtonText}
        <ArrowRight className="h-4 w-4" />
      </Button>
    </div>
  );
};

export default NavigationButtons;
